import React from 'react'
import { UsersManagementContainer } from '@/features/users/components/containers/UsersManagementContainer'

export default function Users() {
  return <UsersManagementContainer />
}
